// extracted by mini-css-extract-plugin
export default {"input":"WidgetUrl_input__czzAe"};